import type { ButtonProps } from '@chakra-ui/react'
import { Center } from '@chakra-ui/react'
import type { FC } from 'react'
import { BsStars } from 'react-icons/bs'

import { Button } from '@app/components/ui/button'

interface Props extends ButtonProps {
  cta?: string
}

export const AiPlaybooksModalTrigger: FC<Props> = ({ cta = 'Build your first map with AI', ...rest }) => (
  <Center>
    <Button colorPalette="purple" {...rest}>
      <BsStars />
      {cta}
    </Button>
  </Center>
)

export default AiPlaybooksModalTrigger
